// extracted by mini-css-extract-plugin
export var paginationContainer = "_3w-0";